/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CategoryListLnb from './CategoryListLnb';

/**
 * The CategoryListGnb model module.
 * @module model/CategoryListGnb
 * @version 1.0
 */
class CategoryListGnb {
    /**
     * Constructs a new <code>CategoryListGnb</code>.
     * @alias module:model/CategoryListGnb
     */
    constructor() { 
        
        CategoryListGnb.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CategoryListGnb</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CategoryListGnb} obj Optional instance to populate.
     * @return {module:model/CategoryListGnb} The populated <code>CategoryListGnb</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryListGnb();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('icon')) {
                obj['icon'] = ApiClient.convertToType(data['icon'], 'String');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('readonly')) {
                obj['readonly'] = ApiClient.convertToType(data['readonly'], 'Boolean');
            }
            if (data.hasOwnProperty('lnbList')) {
                obj['lnbList'] = ApiClient.convertToType(data['lnbList'], [CategoryListLnb]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CategoryListGnb</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CategoryListGnb</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }
        // ensure the json data is a string
        if (data['icon'] && !(typeof data['icon'] === 'string' || data['icon'] instanceof String)) {
            throw new Error("Expected the field `icon` to be a primitive type in the JSON string but got " + data['icon']);
        }
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }
        if (data['lnbList']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['lnbList'])) {
                throw new Error("Expected the field `lnbList` to be an array in the JSON data but got " + data['lnbList']);
            }
            // validate the optional field `lnbList` (array)
            for (const item of data['lnbList']) {
                CategoryListLnb.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} name
 */
CategoryListGnb.prototype['name'] = undefined;

/**
 * @member {Number} gnbNo
 */
CategoryListGnb.prototype['gnbNo'] = undefined;

/**
 * @member {String} pageUrl
 */
CategoryListGnb.prototype['pageUrl'] = undefined;

/**
 * @member {String} icon
 */
CategoryListGnb.prototype['icon'] = undefined;

/**
 * @member {String} key
 */
CategoryListGnb.prototype['key'] = undefined;

/**
 * @member {Boolean} readonly
 */
CategoryListGnb.prototype['readonly'] = undefined;

/**
 * @member {Array.<module:model/CategoryListLnb>} lnbList
 */
CategoryListGnb.prototype['lnbList'] = undefined;






export default CategoryListGnb;

